import React from 'react';
import RModal from '../../../components/Rsuite/Modal';
import { Container } from 'rsuite';
import api from '../../../services/api';
import { useCustomTheme } from '../../../hooks/useCustomTheme';
import { CustomButton } from '../../../components/CustomButton';

const RedefinirSenha = ({ modal, close, entregador }) => {
  const { theme } = useCustomTheme();

  const resetSenha = async () => {
    await api
      .post('entregador/trocarSenha', {
        IdEntregador: entregador.Id,
      })
      .then(() => {
        close();
      });
  };
  return (
    <RModal
      open={modal}
      onClose={close}
      title="Reset de senha"
      footer={
        <CustomButton onClick={resetSenha} appearance="primary">
          Alterar
        </CustomButton>
      }
    >
      <Container>
        <h5 style={{color: theme.colors.textSecondary}}>Tem certeza que deseja redefinir senha?</h5>
      </Container>
    </RModal>
  );
};

export default RedefinirSenha;
